import React from "react";
import { __ } from "@wordpress/i18n";
import Cookies from "universal-cookie";
import { applyFilters } from '@wordpress/hooks';
import { Slot } from '@wordpress/components';
import Button from "../../common/components/inputs/Button";

const userIcon = `${EASYCOMMERCE.assets}admin/img/icons/header-default-user-icon.png`;

const ConnectBox = ({ user, setUser, setShowAPIModal }) => {
	/**
	 * Filters the user data.
	 *
	 * @since 1.0.0
	 * @param {Object|null} user The user object.
	 */
	const filteredUser = applyFilters('easycommerce.settings.connect.user', user);
	const handleDisconnect = () => {
		easycommerce_modal(true);
		fetch(`${EASYCOMMERCE.rest_base}/connectivity/disconnect`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": EASYCOMMERCE.nonce,
			},
		})
			.then(res => res.json())
			.then(data => {
				if (data.success && !data.data?.connected) {
					const cookies = new Cookies(null, { path: "/" });
					cookies.remove("easy-user", { path: "/" });
					window.location.reload();
				}
				easycommerce_modal(false);
			});
	};

	return (
		<>
			<div
				className={`rounded-full overflow-hidden border-ec-border border border-solid bg-white ${
					!filteredUser ? "px-1 pt-2" : "p-0"
				}`}
			>
				<img
					src={!filteredUser ? userIcon : filteredUser?.photo}
					alt="user-icon"
					className="pointer-events-none rounded"
					style={{
						width: "80px",
						height: "80px",
					}}
				/>
			</div>

			{!filteredUser ? (
				<>
					<p className="text-center text-sm text-ec-body font-normal leading-[20px]">
						{__("Your API, Seamlessly Connected", "easycommerce")}{" "}
						<a
							href="https://support.easycommerce.dev"
							target="_blank"
							className="text-[#000000] font-medium underline cursor-pointer"
						>
							{__("Learn more", "easycommerce")}
						</a>
					</p>
					<Button
						className="easycommerce-primary-button px-6"
						value={__("Connect", "easycommerce")}
						onClick={() => setShowAPIModal(true)}
					/>
				</>
			) : (
				<>
					<p className="text-base font-normal text-ec-title text-center leading-[22px]">
						{filteredUser?.name}
					</p>
					<div className="flex items-center gap-2">
						<a
							href="https://my.easycommerce.dev/"
							target="_blank"
							rel="noreferrer"
							className="w-full text-center rounded text-sm text-ec-body hover:text-ec-primary"
						>
							{__("Profile", "easycommerce")}
						</a>
						<div className="h-[13px] w-1 mx-auto bg-[#DFD7FE]"></div>
						<a
							href="https://support.easycommerce.dev"
							target="_blank"
							rel="noreferrer"
							className="w-full text-center rounded text-sm text-ec-body hover:text-ec-primary"
						>
							{__("Support", "easycommerce")}
						</a>
					</div>
					<Button
						className="easycommerce-danger-button px-6 text-ec-light-black text-sm hover:text-ec-primary"
						value={__("Disconnect", "easycommerce")}
						onClick={handleDisconnect}
					/>

                    {/* Slot for additional connect options */}
                    <Slot name="easycommerce.settings.connect.extra" props={{ user: filteredUser }} />
				</>
			)}
		</>
	);
};

export default ConnectBox;
